import { request } from '@/utils/request';

/**
 * 获取货号列表
 */
export function getSnList(data: API.GoodsSnListParms) {
  return request({
    url: '/seller/goodsSn/getGoodsSnListByPage',
    method: 'post',
    data,
  });
}

/**
 * 货号批量上下架
 */
export function updateSNIsOnSale(ids: string, isOnSale: 0 | 1) {
  return request({
    url: '/seller/goodsSn/updateIsOnSale',
    method: 'post',
    data: {
      ids,
      is_on_sale: isOnSale,
    },
  });
}

/**
 * 修改货号
 */
export function editGoodsSn(data: API.GoodsSnEditData) {
  return request({
    url: '/seller/goodsSn/editGoodsSn',
    method: 'post',
    data,
  });
}

/**
 * 获取水洗标模板列表
 */
export function getWashLabelTemplateList(data: API.GetWashLabelTemplateListParam) {
  return request({
    url: '/seller/goodsSnShuixiTemplate/getTemplateListByPage',
    method: 'post',
    data,
  });
}

/**
 * 编辑水洗标
 */
export function editGoodsSnShuixibiao(
  id: number,
  shuixiImageIds: number[],
  material?: string,
  fabric?: string,
) {
  return request({
    url: '/seller/goodsSn/editGoodsSnShuixibiao',
    method: 'post',
    data: {
      id,
      shuixi_image_ids: shuixiImageIds,
      ...(material !== undefined ? { material } : {}),
      ...(fabric !== undefined ? { fabric } : {}),
    },
  });
}

/**
 * 新增水洗标模板
 */
export function addWashLabelTemplate(data: API.AddWashLabelTemplateParam) {
  return request({
    url: '/seller/goodsSnShuixiTemplate/addTemplate',
    method: 'post',
    data,
  });
}

/**
 * 编辑水洗标模板
 */
export function editWashLabelTemplate(data: API.EditWashLabelTemplateParam) {
  return request({
    url: '/seller/goodsSnShuixiTemplate/editTemplate',
    method: 'post',
    data,
  });
}

/**
 * 删除水洗标模板
 */
export function deleteWashLabelTemplate(data: API.DeleteWashLabelTemplateParam) {
  return request({
    url: '/seller/goodsSnShuixiTemplate/deleteTemplate',
    method: 'post',
    data,
  });
}

/**
 * 识别图片中的材质成分
 */
export function recognizeMaterialComposition(imageUrl: string) {
  return request<Record<string, string>>({
    url: '/newapi/goods/category/recognizeMaterialComposition',
    method: 'post',
    data: {
      imageUrl,
    },
  });
}
